import YardOverviewPanel from "./YardOverviewPanel";

/** My Yard tab — bay/dock card grid with occupancy and availability controls. */
export default function MyYardTab(props) {
  return <YardOverviewPanel {...props} />;
}
